/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefUserData } from '../../models/api-def-user-data';

export interface OrganizationsGetUsers$Params {

/**
 * The ID of the organization
 */
  organizationId: string;
}

export function organizationsGetUsers(http: HttpClient, rootUrl: string, params: OrganizationsGetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<{
'user'?: ApiDefUserData;

/**
 * The user's role in the organization
 */
'role'?: 'owner' | 'admin' | 'viewer';
}>>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetUsers.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<{
      'user'?: ApiDefUserData;
      
      /**
       * The user's role in the organization
       */
      'role'?: 'owner' | 'admin' | 'viewer';
      }>>;
    })
  );
}

organizationsGetUsers.PATH = '/organizations/{organizationId}/users';
